import classNames from 'classnames';

import { getFromUrl } from '@shared/helpers/url';
import { useDiscordLoginUrlQuery } from '@shared/hooks/query/user';

import { SocialAuthButtonProps } from '../AuthModal';

const DiscordAuthButton = ({ children, disabled, className }: SocialAuthButtonProps) => {
  const from = getFromUrl();

  const { data: discordLoginUrl } = useDiscordLoginUrlQuery(from || '', {
    enabled: !!from,
  });
  const isDisabled = !discordLoginUrl?.url || disabled;

  return (
    <a
      rel="noreferrer"
      href={discordLoginUrl?.url}
      onClick={(event) => {
        if (disabled) {
          event.preventDefault();
        }
      }}
      className={classNames(
        {
          'grayscale pointer-events-none opacity-40': isDisabled,
        },
        className,
      )}
    >
      {children}
    </a>
  );
};

export default DiscordAuthButton;
